<router-outlet></router-outlet>
<shakespeare-spinning-loader [rotating]="true" *ngIf="isShowingRouteLoadIndicator"></shakespeare-spinning-loader>
<div data-mobile-detector></div>
